import { useSelector } from 'react-redux'
import { isMobileSelector, isDesktopSelector, isTabletSelector } from '@/store/slices/responsive'

const useResponsive = () => ({
  isMobile: useSelector(isMobileSelector),
  isDesktop: useSelector(isDesktopSelector),
  isTablet: useSelector(isTabletSelector)
})

export default useResponsive